




















import Vue from 'vue';
import MessageBox from '../../components/common/MessageBox.vue';

export default Vue.extend({
  components: {
    MessageBox,
  },
  methods: {
    selectText(val: string) {
      this.$store.commit('UPDATE_BROADCAST_TEXT', val);
    },
    updateCouponText(val: string) {
      this.$store.commit('UPDATE_BROADCAST_COUPON_TEXT', val);
    },
    selectImage(val: any) {
      this.$store.commit('UPDATE_BROADCAST_IMAGE', val);
    },
    selectNews(val: any) {
      this.$store.commit('UPDATE_BROADCAST_NEWS', val);
    },
    selectCoupon(val: any) {
      this.$store.commit('UPDATE_BROADCAST_COUPON', val);
    },
    updatePropConfigs(val: any) {
      this.$store.commit('UPDATE_BROADCAST_PROP_CONFIGS', val);
    },
  },
});
